import React, { Component } from "react";

export default class Contact extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const a = document.createElement("a");
        const { who, where } = this.props;

        a.href =
            ["mailto:", who, "@", where, "?", "subject=Au sujet de "].join("") +
            document.location.pathname;
        a.textContent = "Contact";
        a.style.display = "none";
        a.id = "js-micetf-contact";
        document.querySelector("body").appendChild(a);

        this.refs.contact.addEventListener("click", e => {
            e.preventDefault();
            a.click();
        });
    }
    render() {
        return (
            <a
                className="btn btn-default navbar-btn"
                title="Pour contacter le webmaster..."
                ref="contact"
                href="#"
            >
                <span className="glyphicon glyphicon-envelope"></span>
            </a>
        );
    }
}
